import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "./components/SignIn";
import ForgetPassword from "./components/ForgetPassword";
import ResetPassword from "./components/ResetPassword";

const AuthApp = () => (
  <Routes>
    <Route path="/" element={ <SignIn /> } />
    <Route path="/signin" element={ <SignIn /> } />
    <Route path="/forgot-password" element={ <ForgetPassword /> } />
    <Route path="/reset-password" element={ <ResetPassword /> } />
    <Route path="*" element={ <SignIn /> } />
  </Routes>
);

export default AuthApp;
